import { render, staticRenderFns } from "./TalentBar.vue?vue&type=template&id=64425c90&scoped=true"
import script from "./TalentBar.vue?vue&type=script&lang=js"
export * from "./TalentBar.vue?vue&type=script&lang=js"
import style0 from "./TalentBar.vue?vue&type=style&index=0&id=64425c90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64425c90",
  null
  
)

export default component.exports